<div class="dynamic-form formBox" id="formBoxId" (focusin)="rememberNavigationPosition($event)">
  <form (ngSubmit)="onSubmit()" [formGroup]="form">

    <!-- Wrap all normal sections in an accordion (recommended) -->
    <mat-accordion [multi]="true" class="section-accordion">

      @for (section of sections; track section) {
        <mat-expansion-panel
          #panel
          [attr.data-section-number]="section.number"
          [expanded]="section.expanded"
          class="sectionBox"
          [style.overflow]="!expandFlag ? 'unset' : 'hidden'"
          (opened)="onPanelOpened(section)"
          (afterExpand)="focusNextEmptyField(section)"
          (closed)="onPanelClosed(section)">
          <mat-expansion-panel-header (click)="expandWindow(section)">
            <mat-panel-title class="panelTitleBox">
              <div class="panelTitle">
                <h1>{{ section.description }}</h1>
              </div>
              <div class="sectionDescription">
                <app-text-wrapper [toolTip]="sectionDescription[section.number]">
                  {{ sectionDescription[section.number] }}
                </app-text-wrapper>
              </div>
            </mat-panel-title>
            <mat-panel-description class="section-status">
              @if (sectionMissingFlg[section.number]) {
                <div class="section-status__icon">
                  <img class="iconFlag missing" src="./assets/icons/missing.png" alt="missing">
                </div>
              }
              @if (!sectionMissingFlg[section.number]) {
                <div class="section-status__icon">
                  <img class="iconFlag checkingV" src="./assets/icons/checkV.png" alt="valid">
                </div>
              }
            </mat-panel-description>
          </mat-expansion-panel-header>
          <!-- Special case for CAR section 22 -->
          <div class="body-content">
            @if (section.namespace === 'CAR' && section.number === 22) {
              <app-car-type
                [section]="section"
                [questions]="getQuestions(section.number)"
                [navigationOrderByKey]="navigationOrderByKey"
                [navigationStartOrder]="getSectionNavigationOrder(section)"
                [form]="form">
              </app-car-type>
            } @else {
              <!-- SCRUM-154: optional section guidance -->
              @if (section.helpText) {
                <p class="section-help" dir="rtl">
                  <mat-icon aria-hidden="true">lightbulb</mat-icon>
                  <span>{{ section.helpText }}</span>
                </p>
              }
              <!-- SCRUM-231: messages by answer (e.g. קטגוריה = "כלי נשק") -->
              @for (msg of answerMessagesFor(section); track msg.id) {
                <p class="section-help section-help--answer" dir="rtl" role="status"
                   [class.section-help--warning]="msg.level === 'warning'">
                  <mat-icon aria-hidden="true">{{ msg.level === 'warning' ? 'warning_amber' : 'info' }}</mat-icon>
                  <span>{{ msg.text }}</span>
                </p>
              }
              @for (question of getQuestions(section.number); track question) {
                <div
                  class="question-container navigation-question"
                  [attr.data-question-key]="question.key"
                  [attr.data-navigation-order]="getNavigationOrder(question.key)"
                  style="text-align: center;">
                  @if (!(question.type === 'bindSelect' && !question.bindSelectHide) && !isSuppressed(question)) {
                    <app-question
                      [question]="question"
                      [form]="form">
                    </app-question>
                    <!-- SCRUM-155: guidance under the field, one line per row -->
                    @if (question.hint) {
                      <div class="field-hint" dir="rtl">
                        @for (line of question.hint.split('\n'); track $index) {
                          <p>{{ line }}</p>
                        }
                      </div>
                    }
                  }
                </div>
              }
              <!-- SCRUM-154: "upgrade your ad" banner -->
              @if (section.showUpgradeBanner) {
                <div class="upgrade-banner" dir="rtl" role="note">
                  <mat-icon class="upgrade-banner__icon" aria-hidden="true">workspace_premium</mat-icon>
                  <div class="upgrade-banner__copy">
                    <!-- Wording is edited in the admin dashboard (מערכת התראות → הודעות בטופס הפרסום) -->
                    <strong>{{ section.upgradeBannerTitle || 'רוצים יותר פניות?' }}</strong>
                    <span>{{ section.upgradeBannerText || 'מודעה מודגשת או SUPER GOLD מופיעה גבוה יותר בתוצאות ונשארת באוויר זמן רב יותר.' }}</span>
                  </div>
                  <button type="button" class="upgrade-banner__action" (click)="scrollToRoutes()">
                    למסלולי השדרוג
                  </button>
                </div>
              }
            }
          </div>
        </mat-expansion-panel>
      }

    </mat-accordion>

    <!-- Green Pass / Route selection panel (outside the loop) -->
    <mat-expansion-panel
      [expanded]="greenPass"
      [disabled]="!greenPass"
      class="sectionBox route-section">

      <mat-expansion-panel-header>
        <mat-panel-title class="panelTitleBox">
          <div class="panelTitle">
            <h1>{{ "sale4all.label.adv.choose.route" | translate }}</h1>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-panel-description>
        <app-select-route [greenPass]="greenPass"></app-select-route>
      </mat-panel-description>
    </mat-expansion-panel>

  </form>

  <button
    type="button"
    class="field-navigator"
    aria-label="עבור לשדה הבא שטרם מולא"
    title="לשדה הבא"
    (mousedown)="$event.preventDefault()"
    (click)="navigateToNextField()">
    <mat-icon aria-hidden="true">keyboard_arrow_down</mat-icon>
  </button>
</div>
